import React from "react";
import Header from "../../components/Header";
import PricingTables from "../../components/PricingTables";
import Layout from "../../components/Layout";

export default function Shop() {
  return (
    <Layout variant="moreWidth">
      <PricingTables />
    </Layout>
  );
}
